import { useEffect, useState } from "react";
import { authFetch } from "../../../api";
import { occupations } from "../../api/fundsCalculatorApi";
import GlobalDeleteModal from "../Modal/GlobalDeleteModal";
import { DeleteIcon } from "lucide-react";
import ConfimationPopup from "../../../STMPages/components/customPopup/ConfimationPopup";

export default function WorkHistoryTab({
  formData,
  handleInputChange,
  handleWorkStatusChange,
  experiences,
  setExperiences,
  showAddForm,
  setShowAddForm,
  editingIndex,
  setEditingIndex,
  handleEdit,
  handleDelete,
  userId,
  fetchWorkHistory,
  allWorkDeleted,
}) {
  const [jobIndustry, setJobIndustry] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [incomeRange, setIncomeRange] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const fetchJobIndustry = async () => {
    try {
      const response = await occupations();
      setJobIndustry(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchJobType = async () => {
    try {
      const response = await authFetch("application/get-all-job-types", {});
      const data = await response.json();
      setJobType(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchIncome = async () => {
    try {
      const response = await authFetch("application/get-all-income-ranges", {});
      const data = await response.json();
      setIncomeRange(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const formatMonthYear = (dateString) => {
    if (!dateString) return "Present";

    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    });
  };

  const getIndustryName = (id) => {
    const item = jobIndustry.find((i) => i.id === id);
    return item ? item.name : id;
  };

  const getJobTypeName = (id) => {
    const item = jobType.find((i) => i.id === id);
    return item ? item.job_type : id;
  };

  const getIncomeRangeName = (id) => {
    const item = incomeRange.find((i) => i.id === id);
    return item ? item.income_range : id;
  };

  useEffect(() => {
    fetchJobType();
    fetchJobIndustry();
    fetchIncome();
  }, []);

  return (
    <div className="space-y-4">
      {showDeleteModal && (
        <ConfimationPopup
          handleClose={() => setShowDeleteModal(false)}
          open={showDeleteModal}
          component={
            <GlobalDeleteModal
              text="Delete Details ?"
              subText="Are you sure you want to delete your Work History Details?"
              buttonTitle="Delete"
              startIcon={<DeleteIcon />}
              open={showDeleteModal}
              onClose={() => {
                setShowDeleteModal(false);
              }}
              onConfirm={() => {
                handleDelete(deleteIndex);
                setShowDeleteModal(false);
              }}
            />
          }
        />
      )}
      {/* If experiences exist, show Add More button */}
      <div className="flex justify-between mb-4">
        {/* Heading */}
        <div className="text-md font-altisunisa text-black flex items-center gap-2 mb-2">
          <img
            className="h-8 w-8"
            src="/premiumAccess/workHistory.svg"
            alt="workHistory"
          />
          Employment Information
        </div>
        {experiences.length > 0 && (
          <button
            onClick={() => {
              setShowAddForm(!showAddForm);
              setEditingIndex(null);
            }}
            className="px-4 py-2 bg-[#572575] text-white rounded-lg text-sm font-medium"
          >
            {showAddForm ? "Close" : "+ Add More"}
          </button>
        )}
      </div>
      {/* main */}
      {(experiences.length === 0 || showAddForm) && (
        <div>
          {/* Have you worked? */}
          {!allWorkDeleted && experiences.length === 0 && !showAddForm && (
            <div>
              <label className="block mb-2 font-medium text-black font-semibold">
                Have you worked in any organization before? *
              </label>
              <div className="flex gap-6 items-center p-2">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="hasWorked"
                    value="yes"
                    checked={formData.hasWorked === "yes"}
                    onChange={handleInputChange}
                  />
                  Yes
                </label>

                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="hasWorked"
                    value="no"
                    checked={formData.hasWorked === "no"}
                    onChange={handleInputChange}
                  />
                  No
                </label>
              </div>
            </div>
          )}

          {/* Show only if user has NOT worked */}
          {formData.hasWorked === "no" && (
            <div className="w-full bg-white border rounded-xl p-6 flex flex-col items-center justify-center text-center space-y-3">
              <img
                src="/NoWorkHistory.png"
                alt="no-work"
                className="h-24 w-24"
              />

              <h2 className="font-inter text-xl font-semibold text-black">
                No Work Experience ?
              </h2>

              <p className="font-inter text-gray-600 max-w-md">
                No work experience yet? That’s perfectly fine.Let’s move
                forward—you can update this later.
              </p>
            </div>
          )}

          {/* Show Deleted work history ONLY if user deleted all */}
          {allWorkDeleted &&
            experiences.length === 0 &&
            formData.hasWorked === "yes" && (
              <div className="w-full bg-white border rounded-xl p-6 flex flex-col items-center justify-center text-center space-y-3">
                <img
                  src="/NoWorkHistory.png"
                  alt="no-work"
                  className="h-24 w-24"
                />

                <h2 className="font-inter text-xl font-semibold text-black">
                  No Work History Details saved Yet
                </h2>

                <p className="font-inter text-gray-600 max-w-md">
                  Your previous work history have been removed. You can add them
                  again to continue your application.
                </p>
                <button
                  onClick={() => window.location.reload()}
                  className="px-6 py-2 bg-[#572575] text-sm text-white rounded-lg"
                >
                  Add Work History
                </button>
              </div>
            )}

          {/* Show only if user has worked */}
          {!allWorkDeleted && formData.hasWorked === "yes" && (
            <div className="grid grid-cols-2 gap-6 bg-white p-4 border rounded-xl">
              {/* Organization */}
              <div className="col-span-2">
                <label className="block mb-1 text-black">
                  Name of Organization *
                </label>
                <input
                  type="text"
                  name="organization"
                  value={formData.organization}
                  onChange={handleInputChange}
                  className="border w-full p-2 rounded-lg"
                  placeholder="Enter Organization Name"
                />
              </div>

              {/* Currently Working */}
              <div className="col-span-2 flex items-center gap-2">
                <input
                  type="checkbox"
                  name="currentlyWorking"
                  checked={formData.currentlyWorking}
                  onChange={(e) => handleWorkStatusChange(e.target.checked)}
                />
                <span className="text-gray-700 font-medium">
                  Currently Working
                </span>
              </div>

              {/* Working From */}
              <div>
                <label className="block mb-1 text-black">Working From *</label>
                <input
                  type="month"
                  name="workingFrom"
                  value={formData.workingFrom}
                  onChange={handleInputChange}
                  className="border w-full p-2 rounded-lg"
                />
              </div>

              {/* Working Till — hide when currentlyWorking is true */}
              {!formData.currentlyWorking && (
                <div>
                  <label className="block mb-1 text-black">Working Till</label>
                  <input
                    type="month"
                    name="workingTill"
                    value={formData.workingTill}
                    onChange={handleInputChange}
                    className="border w-full p-2 rounded-lg"
                  />
                </div>
              )}

              {/* Job Industry */}
              <div>
                <label className="block mb-2 text-black">Job Industry *</label>
                <select
                  name="jobIndustry"
                  value={formData.jobIndustry}
                  onChange={handleInputChange}
                  className="border w-full p-2 rounded-lg"
                >
                  <option value="">Select Industry</option>
                  <option value="90">Test</option>

                  {jobIndustry?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Job Role */}
              <div>
                <label className="block mb-2 text-black">Job Role *</label>
                <input
                  placeholder="Enter job role"
                  type="text"
                  name="jobRole"
                  value={formData.jobRole}
                  onChange={handleInputChange}
                  className="border w-full p-2 rounded-lg"
                />
              </div>

              {/* Job Type */}
              <div>
                <label className="block mb-2 text-black">
                  Job Type <span className="text-red">*</span>
                </label>
                <select
                  name="jobType"
                  value={formData.jobType}
                  onChange={handleInputChange}
                  className="border w-full p-2 rounded-lg"
                >
                  <option value="">Select Job Type</option>

                  {jobType?.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.job_type}
                    </option>
                  ))}
                </select>
              </div>

              {/* Income */}
              <div>
                <label className="block mb-2 text-black">
                  Income (As per ITR) *
                </label>
                <select
                  name="income"
                  value={formData.income}
                  onChange={handleInputChange}
                  className="border w-full p-2 rounded-lg"
                >
                  <option value="">Select your Income Range</option>

                  {incomeRange?.map((inc) => (
                    <option key={inc.id} value={inc.id}>
                      {inc.income_range}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>
      )}
      {/* Show saved experiences */}
      {experiences.length > 0 && editingIndex === null && (
        <div className="space-y-4 mb-6">
          {experiences.map((exp, index) => (
            <div
              key={index}
              className="bg-[#FFF6FB] border border-[#F3D9EA] rounded-xl p-6"
            >
              {/* Title + Actions */}
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-lg font-semibold text-black">
                  {exp.name_of_organization}
                </h2>

                <div className="flex gap-4 text-sm ">
                  <button
                    onClick={() => handleEdit(index)}
                    className="text-[#177BE5] text-sm font-semibold hover:underline"
                  >
                    ✎ Edit
                  </button>
                  <button
                    onClick={() => {
                      setDeleteIndex(index);
                      setShowDeleteModal(true);
                    }}
                    className="text-[#D20000] text-sm font-semibold hover:underline"
                  >
                    🗑 Delete
                  </button>
                </div>
              </div>

              {/* Columns */}
              <div className="grid grid-cols-2 gap-2">
                {/* Working From */}
                <div>
                  <p className="text-sm text-gray-600 mb-1">
                    Working From <span className="text-red-600">*</span>
                  </p>
                  <div
                    className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-medium font-semibold text-black"
                    style={{ borderColor: "#F3D9EA" }}
                  >
                    {formatMonthYear(exp.working_from)}
                  </div>
                </div>

                {/* Working Till */}
                <div>
                  <p className="text-sm text-gray-600 mb-1">
                    Working Till <span className="text-red-600">*</span>
                  </p>
                  <div
                    className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-medium font-semibold text-black"
                    style={{ borderColor: "#F3D9EA" }}
                  >
                    {formatMonthYear(exp.working_to) || "Present"}
                  </div>
                </div>

                {/* Job Industry */}
                <div>
                  <p className="text-sm text-gray-600 mb-1">
                    Job Industry <span className="text-red-600">*</span>
                  </p>
                  <div
                    className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-medium font-semibold text-black"
                    style={{ borderColor: "#F3D9EA" }}
                  >
                    {getIndustryName(exp.job_industry)}
                  </div>
                </div>

                {/* Job Role */}
                <div>
                  <p className="text-sm text-gray-600 mb-1">
                    Job Role <span className="text-red-600">*</span>
                  </p>
                  <div
                    className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-medium font-semibold text-black"
                    style={{ borderColor: "#F3D9EA" }}
                  >
                    {exp.job_role}
                  </div>
                </div>

                {/* Job Type */}
                <div>
                  <p className="text-sm text-gray-600 mb-1">
                    Job Type <span className="text-red-600">*</span>
                  </p>
                  <div
                    className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-medium font-semibold text-black"
                    style={{ borderColor: "#F3D9EA" }}
                  >
                    {getJobTypeName(exp.job_type)}
                  </div>
                </div>

                {/* Income */}
                <div>
                  <p className="text-sm text-gray-600 mb-1">
                    Income (As per ITR) <span className="text-red-600">*</span>
                  </p>
                  <div
                    className="h-10 bg-white border rounded-md px-3 flex items-center text-sm font-medium font-semibold text-black"
                    style={{ borderColor: "#F3D9EA" }}
                  >
                    {getIncomeRangeName(exp.income)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
